export default {
  // Leveringsbetingelser
  deliveryTermsTitle: 'Leveringsbetingelser',
  deliveryTermsSubtitle: 'Vilkår og betingelser for levering af el fra enkel energi',
  
  // Privatlivspolitik
  privacyPolicyTitle: 'Privatlivspolitik',
  privacyPolicySubtitle: 'Sådan behandler vi dine personoplysninger',
  
  // Cookiepolitik
  cookiePolicyTitle: 'Cookiepolitik',
  cookiePolicySubtitle: 'Information om brug af cookies på vores hjemmeside',
  
  // Handelsbetingelser
  tradingTermsTitle: 'Handelsbetingelser',
  tradingTermsSubtitle: 'Generelle handelsbetingelser for enkel energi',
  
  // Common legal
  lastUpdated: 'Sidst opdateret',
  effectiveDate: 'Gældende fra',
  questions: 'Spørgsmål?',
  contactForQuestions: 'Hvis du har spørgsmål til vores vilkår, er du velkommen til at kontakte os.',
};